import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  interfaceHide: false,
};

// Create slice
const hideInterfaceSlice = createSlice({
  name: "HideInterface",
  initialState,
  reducers: {
    setHideInterfaceStatus: (state, action) => {
      state.interfaceHide = action.payload;
    },
  },
});

// Export action and reducer
export const { setHideInterfaceStatus } = hideInterfaceSlice.actions;
export default hideInterfaceSlice.reducer;
